module.exports = __webpack_public_path__ + "static/media/AB_O1_7.f6fef044.jpg";